import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { addDays, subDays } from 'date-fns';
import { getScheduleDate } from '@/store/selectors/schedule';

import DateSwitchComponent from '@/components/SchedulePage/DateSwitch/DateSwitchComponent';
import { useConfirmAlert } from '@/contexts/ConfirmAlertContext';
import { setDate, setInspectorsAvailabilities, setUnsaved } from '@/store/ducks/schedule';

const DateSwitchContainer = () => {
  const date = useSelector(getScheduleDate);
  const unsaved = useSelector(state => state.schedule.unsaved);
  const dispatch = useDispatch();
  const intl = useIntl();

  const { openConfirmAlert } = useConfirmAlert();

  const changeDate = newDate => {
    newDate.setHours(0, 0, 0, 0);
    dispatch(setDate(newDate));
    dispatch(setUnsaved(false));
  };

  const handleChange = newDate => {
    if (unsaved) {
      openConfirmAlert({
        message: intl.formatMessage({
          id: 'THERE_ARE_CHANGES_NOT_SENT_TO_DEVICES_MESSAGE',
        }),
        onConfirm: () => {
          changeDate(newDate);
          dispatch(setInspectorsAvailabilities());
        },
      });
    } else {
      changeDate(newDate);
      dispatch(setInspectorsAvailabilities());
    }
  };

  const handleNavigateDateNext = currentDate => {
    const nextDate = addDays(currentDate, 1);
    handleChange(nextDate);
  };

  const handleNavigateDateBefore = currentDate => {
    const prevDate = subDays(currentDate, 1);
    handleChange(prevDate);
  };

  return (
    <DateSwitchComponent
      date={date}
      handleChange={handleChange}
      handleNavigateDateNext={handleNavigateDateNext}
      handleNavigateDateBefore={handleNavigateDateBefore}
    />
  );
};

export default DateSwitchContainer;
